export default {
  getItems (storeId, orderId) {
    return fetch(`/order/items?store_id=${storeId}&order_id=${orderId}`)
      .then(data => data.json())
  }
}



// WEBPACK FOOTER //
// ./src/services/api.js